@if (screeningResult) {
  <div class="result-list" [class.editable]="editable()">
    @for (result of screeningResult; track $index) {
      <div class="result-list--item" (click)="editItem($index)">
        <div class="result-list--text border"
             [ngClass]="isPassed(result)? 'border--passed':'border--failed'">
          <span class="result-list--criteria">{{ result.criteria }}</span>
          <span class="result-list--reason">{{ result.reason }}</span>
          @if (result.manuelOverride && result.manuelReason) {
            <span class="result-list--or-reason">Overwritten: {{ result.manuelReason }}</span>
          }
        </div>
      </div>
      @if ($index === editMode) {
        <mat-form-field class="full-width override">
          <mat-slide-toggle
            [(ngModel)]="override"
            matPrefix></mat-slide-toggle>
          <mat-label>Override {{ result.criteria }}</mat-label>
          <textarea type="email" matInput
                    [disabled]="!override"
                    [(ngModel)]="reason"
                    required
                    placeholder="Text include {{result.criteria}}"></textarea>
          <button
            (click)="save()"
            [disabled]="disableSave()"
            matSuffix mat-icon-button>
            <mat-icon>save</mat-icon>
          </button>
          <mat-hint>The outcome of Academate is negated</mat-hint>
        </mat-form-field>
      }
    }
  </div>
} @else {
  <p>No results, please run Screening</p>
}


